import { render, staticRenderFns } from "./Lgx240151068820897792.vue?vue&type=template&id=77bd326e&"
import script from "./Lgx240151068820897792.vue?vue&type=script&lang=js&"
export * from "./Lgx240151068820897792.vue?vue&type=script&lang=js&"
import style0 from "./Lgx240151068820897792.vue?vue&type=style&index=0&id=77bd326e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports